<div class="task-step-c" [formGroup]="formGroup">
    <h2 class="col-12" *ngIf="false">Deliveries</h2>
    <div class="schedules-wrapper" *ngIf="schedules.length > 0; else noSchedules">
        <div class="actions">
            <button
              type="button"
              class="btn btn-primary add-schedule"
              (click)="onAddScheduleClick()"
              i18n="Add schedule button label at the task schedule configuration step of the task wizard@@addScheduleButtonLabelTaskWizard"
            >Add Schedule</button>
        </div>
        <table class="table table-striped table-advance table-hover schedules">
            <thead>
            <tr>
                <th class="type" i18n="Recurrence column at the schedule list of a task@@recurrenceColumnLabelTaskEdit">Recurrence</th>
                <th class="rule" i18n="Rule column at the schedule list of a task@@ruleColumnLabelTaskEdit">Rule</th>
                <th class="local" i18n="Local Time column at the schedule list of a task@@localTimeColumnLabelTaskEdit">Local Time</th>
                <th class="actions" i18n="Actions column at the schedule list of a task@@actionsColumnLabelTaskEdit">Actions</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let schedule of schedules" [attr.data-id]="schedule.idSchedules">
                <td class="type">{{ getTypeLabel(schedule.Type) }}</td>
                <td class="rule">{{ schedule.RuleString }}</td>
                <td class="local">{{ getLocalTimeFromData(schedule) }}</td>
                <td class="actions">
                    <button
                        [ngClass]="{'btn': true, 'btn-info': true, 'deactivated':schedule.Status !== 'A', 'btn-xs': true, 'btn-status': true}"
                        type="button"
                        (click)="onStatusClick(schedule)"
                    >
                      <i [ngClass]="{'fa': true, 'fa-check-circle': schedule.Status === 'A', 'fa-times-circle': schedule.Status !== 'A'}"></i>
                      <span
                        *ngIf="schedule.Status === 'A'"
                        i18n="enabled indicator text|The text or button label of something that is active or will be activated@@enabledIndicatorText"
                      >Enabled</span>
                      <span
                        *ngIf="schedule.Status !== 'A'"
                        i18n="disabled indicator text|The text or button label of something that is not active or will be disabled@@disabledIndicatorText"
                      >Disabled</span>
                    </button>
                    <button class="btn btn-primary btn-xs" type="button" (click)="onEditScheduleClick(schedule)"><i class="fa fa-pencil"></i></button>
                    <button class="btn btn-danger btn-xs" type="button" (click)="onDeleteScheduleClick(schedule)"><i class="fa fa-trash-o"></i></button>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
    <ng-template #noSchedules>
        <div class="missing-schedule-info">
            <h3 i18n="no schedule note|The message shown at the top of the schedule list when there are no schedules registered to a task at the task edit form@@noRegisteredSchedulesTitleTaskForm">There are no schedules for this task yet.</h3>
            <p>
                <button
                  type="button"
                  class="btn btn-primary add-schedule"
                  (click)="onAddScheduleClick()"
                  i18n="click here to add button label|The label of the button indicading that the button should be clicked to achieve a goal that is described at a label present at its right@@clickHereLabelAtRightButton"
                >Click here</button>
                <span i18n="the label describing add delivery to the click here button|The label at the right of the button indicading that the button should be clicked to add a new delivery to a task form@@addNewDeliveryButtonExplanation">to add a new schedule</span>
            </p>
            <p class="long-description" i18n="schedule description|The message explaining schedules that is shown at the schedule list when there are no schedules registered to a task at the task edit form@@noRegisteredSchedulesDescriptionTaskForm">With schedules you can schedule a monthly, weekly or daily report.</p>
        </div>
    </ng-template>
</div>
